import { Injectable, Injector } from '@angular/core';
import {
 HttpEvent,
 HttpInterceptor,
 HttpHandler,
 HttpRequest,
 HttpResponse,
 HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { AuthService } from '../services/authentication/auth.service';
import { AlertService } from '../services/alert.service';

@Injectable({ providedIn: 'root' })
export class HttpErrorInterceptor implements HttpInterceptor {
 constructor(private injector: Injector,
             protected authService: AuthService,
             protected alertService: AlertService) { }

 intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
   return next.handle(request)
     .pipe(
       retry(0),
       catchError((error: HttpErrorResponse) => {
         console.log('handleError');
         console.log(JSON.stringify(error));
          if (error.error != null) {
            if (error.error.Code != null && error.error.Code !== '') {
              if (error.error.Code == 403) {
                this.authService.logoutUser(true);
              } else {
                this.alertService.error(`Error : ${error.message} (${error.error.Code}->${error.error.Error})`);
              }
            } else {
              this.alertService.error(`Error : ${error.error}`);
            }
          } else {
              this.alertService.error(`Error : ${error}`);
          }
         return throwError(error);
       })
     )
 }
}
